var keys = {
  allFields: 'allFields',
  "default": 'default',
  custom: 'custom',
  predefined: 'predefined',
  saved: 'saved'
};

export { keys };
//# sourceMappingURL=keys.esm.js.map
